module.exports = __webpack_public_path__ + "media/images/login-908fa8cf66b74f68c939f0ecce3a0c2a.jpg";